import React, { KeyboardEvent } from 'react';

import { Variants } from '@sede-x/shell-ds-react-base';

import { ClearIcon } from '../Icons/Icons';
import Button from '../../../Button/Button';

const ClearButton = () => {
  const onClick = (e: KeyboardEvent) => {
    if (e.key !== ' ' && e.key !== 'Enter') {
      return;
    }

    e.stopPropagation();

    const target = e.target as HTMLButtonElement;
    target.parentElement?.dispatchEvent(
      new MouseEvent('mousedown', {
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1,
      }),
    );
  };

  return <Button icon={<ClearIcon />} iconOnly onKeyDown={onClick} variant={Variants.Transparent} aria-label="Clear" />;
};

export default ClearButton;
